// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"b37ed8e2","453":"2f35bb41","796":"ca9e33c4"}[chunkId] + ".chunk.js";
};